export default {
  // nav
  home: "Home",
  suppliers: "Suppliers",
  corporat: "Corporat",
  buyer: "Buyer",
  contactUs: "Contact us",
  mySupply: "MySupply",
  allRightsReserved: "All Rights Reserved",
  bestDeal: "Best Deals",
  dailyOffers: "Daily Offers",
  monthlyOffers: "Special Offers",
  about: "About us",
  vision: "Vision",
  message: "Message",
  myPrinciples: "My Principles",
  registerForTheNewsletter: "Register for the newsletter",
  beTheFirstToGetExclusiveOffersAndCoupons:
    "Be the first to get exclusive offers and coupons",
  subscribe: "Subscribe",
  email: "Email Address",
  kuwait: "Kuwait",
  cart: "Cart",
  KWD: "KWD",
  USD: "USD",
  showAll: "Show all",
  noData: "No Data Available",
  tilNow: "Till Now",
  noDataTill: "No Data Available",
  All: "All",
  vendors: "Clienteles",
  pageNoteFound1: "THE PAGE YOU WERE LOOKING FOR DOESN'T EXIST.",
  you: "You",
  ok: "Ok",
  privacyPolicy: "Privacy & Policy",
  termsConditions: "Terms & Conditions",
  faq: "FAQ",
  siteName: "HumHumm Support",
  siteSupport: "Typical response within one hour",
  hiThere: "Hi there",
  helpYou: "How can I help you?",
  startCaht: "Start Chat",
  navSuppliers: "PARTNERS",
  clients: "Clients",
  consumerCategory: "Consumer Category",
  corporateCategory: "Corporate Category",
  registerThank: "Thanks for Registeration",
};
